/*
 * cart-terms.js
 *
 * Erstatter Canopys oprindelige browser-alert() paa handelsbetingelserne.
 *
 * Jakob 17. september 2026: den graa systemboks hverken fremhaevede eller
 * rullede hen til afkrydsningen, saa kunden selv skulle finde ud af hvad der
 * var galt - paa det sidste skridt foer betaling.
 *
 * Nu: submit stoppes, siden ruller hen til afkrydsningen, feltet faar fokus
 * og en roed ramme, og der staar en besked ved siden af. Alt sammen fjernes
 * igen i samme oejeblik kunden saetter fluebenet.
 *
 * Teksten kommer fra theme.strings.cartTermsConfirmation, saa den foelger
 * butikkens sprogfil. Falder tilbage paa en dansk saetning, hvis strengen
 * mangler.
 *
 * Ingen afhaengigheder, ingen ekstra CSS-fil. Farven er brandets roede
 * (#C8332B), den samme som knapperne.
 */
if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.handleChange.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }

    /**
     * Teksten der vises. Sprogfilen foerst, dansk fallback bagefter.
     * @returns {string}
     */
    get beskedTekst() {
      var fra = null;
      try {
        fra = theme.strings.cartTermsConfirmation;
      } catch (e) {
        fra = null;
      }
      if (typeof fra === 'string' && fra.trim().length) return fra.trim();
      return 'Du skal acceptere vilkaar og handelsbetingelser, foer du kan gaa til betaling.';
    }

    /**
     * Beskedelementet. Laves foerste gang der er brug for det.
     * @returns {HTMLElement}
     */
    get besked() {
      if (this._besked && this._besked.isConnected) return this._besked;
      var el = this.querySelector('[data-cart-terms-fejl]');
      if (!el) {
        el = document.createElement('p');
        el.setAttribute('data-cart-terms-fejl', '');
        el.setAttribute('role', 'alert');
        el.id = 'cart-terms-fejl';
        el.style.cssText = [
          'margin:6px 0 0',
          'color:#C8332B',
          'font-size:0.875rem',
          'line-height:1.35',
          'display:none'
        ].join(';');
        this.appendChild(el);
      }
      this._besked = el;
      return el;
    }

    /**
     * Viser fejlen, ruller derhen og saetter fokus.
     */
    vis() {
      var boks = this.cartTermsCheckbox;
      var el = this.besked;
      el.textContent = this.beskedTekst;
      el.style.display = 'block';

      boks.setAttribute('aria-invalid', 'true');
      boks.setAttribute('aria-describedby', el.id);
      boks.style.outline = '2px solid #C8332B';
      boks.style.outlineOffset = '2px';

      var maal = boks.closest('label') || boks;
      try {
        maal.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (e) {
        maal.scrollIntoView();
      }
      try {
        boks.focus({ preventScroll: true });
      } catch (e) {
        boks.focus();
      }
    }

    /**
     * Rydder fejlen igen.
     */
    ryd() {
      var boks = this.cartTermsCheckbox;
      if (this._besked) this._besked.style.display = 'none';
      boks.removeAttribute('aria-invalid');
      boks.removeAttribute('aria-describedby');
      boks.style.outline = '';
      boks.style.outlineOffset = '';
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        this.vis();
      } else {
        this.ryd();
      }
    }

    /**
     * Rydder beskeden i samme oejeblik fluebenet saettes.
     */
    handleChange() {
      if (this.cartTermsCheckbox.checked) this.ryd();
    }
  }
  customElements.define('cart-terms', CartTerms);
}